/* 6FT Club site enhancements: headline sheen, search suggestions, typing placeholder and footer payment row. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var PHRASES = [
    'Search for Height Increase Insoles',
    'Search for Elevator Shoes',
    'Search for Low Top Elevator Shoes',
    'Search for Chelsea Boots',
    'Search for Boots'
  ];

  var KEYWORDS = [
    'Height Increase Insoles',
    'Elevator Shoes',
    'Low Top Elevator Shoes',
    'Chelsea Boots',
    'Boots'
  ];

  /* Headline sheen: a light sweep that repeats every 7 seconds while the heading is on screen. */
  function initSheen() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var nodes = document.querySelectorAll('main h1, main h2, #MainContent h1, #MainContent h2');
    if (!nodes.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting) {
          if (!el.classList.contains('sheen-run')) {
            el.style.setProperty('--sheen-base', window.getComputedStyle(el).color);
            el.classList.add('sheen-run');
          }
        } else {
          el.classList.remove('sheen-run');
        }
      });
    }, { threshold: 0.6 });

    Array.prototype.forEach.call(nodes, function (el) {
      observer.observe(el);
    });
  }

  /* Footer: stretch the payment icons across the same width as the email signup, so both ends line up. */
  function initPaymentRow() {
    var row = document.querySelector('.site-footer__payments');
    var form = document.querySelector('.site-footer__newsletter');
    if (!row || !form) return;

    var sync = function () { row.style.width = form.offsetWidth + 'px'; };
    sync();
    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(form);
    } else {
      window.addEventListener('resize', sync);
    }
  }

  /* Ghost text: types out each search phrase in the empty search box, then erases it. */
  function startTyping(input, label) {
    if (reduceMotion) {
      input.placeholder = PHRASES[1];
      return;
    }
    var original = label ? label.textContent : '';
    var phraseIndex = 0;
    var charIndex = 0;
    var deleting = false;

    function step() {
      var delay = 70;
      if (input.value === '') {
        var phrase = PHRASES[phraseIndex];
        if (!deleting) {
          charIndex += 1;
          if (charIndex >= phrase.length) {
            charIndex = phrase.length;
            deleting = true;
            delay = 1800;
          }
        } else {
          charIndex -= 1;
          delay = 35;
          if (charIndex <= 0) {
            charIndex = 0;
            deleting = false;
            phraseIndex = (phraseIndex + 1) % PHRASES.length;
            delay = 500;
          }
        }
        var shown = phrase.slice(0, charIndex);
        input.placeholder = shown;
        if (label) label.textContent = shown || original;
      } else {
        if (label && label.textContent !== original) label.textContent = original;
        delay = 500;
      }
      window.setTimeout(step, delay);
    }

    window.setTimeout(step, 600);
  }

  /* Search box: a popular-searches dropdown appears when the box is clicked while empty. */
  function setupInput(input) {
    if (input.getAttribute('data-suggest-ready')) return;
    input.setAttribute('data-suggest-ready', 'true');

    var field = input.closest('.field') || input.parentNode;
    var panel = document.createElement('div');
    panel.className = 'search-suggest';
    panel.hidden = true;

    var title = document.createElement('p');
    title.className = 'search-suggest__title';
    title.textContent = 'Popular searches';

    var list = document.createElement('ul');
    list.className = 'search-suggest__list';
    KEYWORDS.forEach(function (keyword) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '/search?q=' + encodeURIComponent(keyword);
      link.textContent = keyword;
      item.appendChild(link);
      list.appendChild(item);
    });

    panel.appendChild(title);
    panel.appendChild(list);
    field.parentNode.insertBefore(panel, field.nextSibling);

    /* Keep focus in the input when a suggestion is pressed, so the click still registers. */
    panel.addEventListener('mousedown', function (event) { event.preventDefault(); });

    function refresh() {
      panel.hidden = !(document.activeElement === input && input.value.trim() === '');
    }
    input.addEventListener('focus', refresh);
    input.addEventListener('input', refresh);
    input.addEventListener('blur', function () { panel.hidden = true; });

    var label = input.labels && input.labels[0];
    startTyping(input, label);
  }

  function initSearch() {
    var inputs = document.querySelectorAll('form[action*="/search"] input[name="q"]');
    Array.prototype.forEach.call(inputs, setupInput);
  }

  function init() {
    initSearch();
    initSheen();
    initPaymentRow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
